var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-action-btn',{attrs:{"wrapper-class":"mb-0 pointer","access":_vm.canModifyTableRows(_vm.role),"show-tooltip":!_vm.canModifyTableRows(_vm.role),"top":""},on:{"click":function($event){_vm.canModifyTableRows(_vm.role).allowed && _vm.onManageRow({
    tableId: _vm.scheduleId,
    tableType: _vm.tableType,
    rowId: _vm.rowId,
    projectId: _vm.$route.params.id,
    status: _vm.status
  })}},scopedSlots:_vm._u([{key:"iconWrapper",fn:function(){return [_c('v-icon',{attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.status === 'hidden' ? 'mdi-eye' : 'mdi-eye-off')+" ")])]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.status === 'hidden' ? 'Unhide' : 'Hide')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }